/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.19.0
 */

import { ReactNode } from 'react';

import classNames from 'classnames';
import { CellProps } from 'react-table';

export type TTableCell<Data extends object> = CellProps<Data>;

type TTableCellRender<Data extends object> = (props: { row: Data, value: string }) => ReactNode;

const getStyles = (props: any, align = 'left') => [
    props,
    {
        style: {
            textAlign: align === 'right' ? 'right' : 'left',
        },
    },
];

const cellProps = (props: any, { cell }: any) => getStyles(props, cell.column.align);

const TableCell = <Data extends object>(props: CellProps<Data>) =>
    ({ render, rowDouble }: { render: TTableCellRender<Data>, rowDouble?: boolean }) => {
        return (
            <div
                {...props.cell.getCellProps(cellProps)}
                className={classNames('rt-td td cell', { rowDouble })}
                data-col-name={props.cell.column.id}
                data-name={`table-column-${props.cell.column.id}`}
            >
                {render({
                    row: props.row.original,
                    value: props.value?.toString() ?? '',
                })}
            </div>
        );
    };

export default TableCell;
